import { LocationClientService, CallingCodeModel } from '@/types/locationServerApi';
import { computed, Ref, ref } from 'vue';
import { orderBy } from 'lodash';
import siteContextStore from '@/shared/content/site-context.store';
import utilities from '@/shared/utilities.service';

export const callingCodesCancellationKey = 'callingCodesCancellationKey';

let loaded: boolean = false;
const codes: Ref<CallingCodeModel[]> = ref([] as CallingCodeModel[]);

export default function useCallingCodes() {
    const fetchCodes = async(): Promise<void> => {
        if (!loaded) {
            loaded = true;
            try {
                const response = await LocationClientService.getCallingCodes(callingCodesCancellationKey).then(utilities.unwrapModel);
                codes.value = response ? orderBy(response, 'code') : [] as CallingCodeModel[];
            } catch (e) {
                loaded = false;
            }
        }
    };

    const getMatchingCodeString = (phone: string | undefined): string => {
        if (phone === undefined) {
            return '';
        }
        let matchingCode: string = '';
        orderBy(codes.value, code => code.code?.length ?? 0, 'desc').some(code => {
            if (code.code && phone.indexOf(code.code) === 0) {
                matchingCode = code.code;
                return true;
            }
            return false;
        });
        return matchingCode;
    };

    const stripCode = (phone: string | undefined): string => {
        if (phone === undefined) {
            return '';
        }
        const matchingCode = getMatchingCodeString(phone);
        return phone.replace(matchingCode, '');
    };

    const formatCodes = (codes: string[]): string => {
        return codes[0].toUpperCase();
    };

    const mostRelevantCodeForSite: Ref<string> = computed(() => {
        const currentLanguage = siteContextStore.settings.language.toLowerCase();
        const relevantCode = codes.value.find(code => code.language?.toLowerCase() === currentLanguage) || codes.value[0];
        return relevantCode?.code ?? '';
    });

    fetchCodes();

    return {
        codes,
        stripCode,
        formatCodes,
        getMatchingCodeString,
        mostRelevantCodeForSite,
    };
}
